<mat-form-field *ngIf="!readonly" class="w-100" [ngClass]="{ 'no-label': hideLabel }">
  <input
    matInput
    [attr.data-automation-id]="dataAutomationId"
    [required]="fgInfo.required"
    placeholder="{{ labelOverride || fgInfo?.label }}{{ formControl['condrequired'] || fgInfo?.required ? '*' : '' }}"
    [formControl]="formControl"
    [ngxTimepicker]="picker"
    [disableClick]="true"
    readonly
  />
  <span matSuffix>
    <ngx-material-timepicker-toggle [for]="picker"></ngx-material-timepicker-toggle>
    <ngx-material-timepicker #picker></ngx-material-timepicker>
  </span>
  <mat-hint>{{ hint }}</mat-hint>
  <mat-error *ngFor="let errorDefinition of errorDefinitions">
    <ng-container *ngIf="errorDefinition.showFunction()">
      {{ errorDefinition.errorMessage(formControl) }}
    </ng-container>
  </mat-error>
</mat-form-field>
<ng-container *ngIf="readonly">
  <mat-form-field
    class="no-underline w-100"
    [floatLabel]="'always'"
    [ngClass]="{ 'read-only': readonly, 'no-label': hideLabel }"
  >
    <mat-label>{{ labelOverride || fgInfo?.label }}</mat-label>
    <input
      readonly
      matInput
      [attr.data-automation-id]="dataAutomationId"
      [value]="formControl.value"
      tabindex="-1"
    />
  </mat-form-field>
</ng-container>
